export const generalTexts = {
  confirmAndContinu: "تایید اطلاعات و ادامه",
  returnToBeforePage: "بازگشت به صفحه قبل",
  saveAddressAndContinue: "ثبت آدرس و ادامه",
  optional: "اختیاری",
};
